import { graphql } from "react-relay";

// ONE query behind both surfaces — the footer that every page carries and the
// queue page itself. A second query per page view would be a cost paid forever
// for no extra information.
//
// The selection is written out twice rather than shared through a fragment: a
// masked fragment would hand each surface an opaque ref it cannot read, and the
// two lists are the same shape by definition, so the duplication is honest.
export const accountQueueQuery = graphql`
  query queueFragment_Query($history: Int) {
    accountQueue(history: $history) {
      activeCount
      queuedKinds
      startableKinds {
        kind
        label
        params
      }
      schedules {
        scheduleId
        kind
        label
        cadence
        everyMinutes
        nextRunAt
        enabled
        due
        lastRunAt
        lastJobId
        createdBy
      }
      running {
        jobId
        label
        status
        phase
        currentObject
        rowsProcessed
        rowsTotal
        unit
      }
      active {
        jobId
        kind
        label
        status
        phase
        currentObject
        rowsProcessed
        rowsTotal
        unit
        errorMessage
        params
        source
        requestedBy
        parentJobId
        supersededByJobId
        attempts
        startedAt
        finishedAt
        createdAt
        cancelRequestedAt
        stalled
        terminal
        queuePosition
        blocker
        stagesTotal
        stagesDone
        stageLabels {
          key
          label
          state
        }
        outcome {
          key
          value
        }
        typicalSeconds
        etaSeconds
        childJobIds
      }
      history {
        jobId
        kind
        label
        status
        phase
        currentObject
        rowsProcessed
        rowsTotal
        unit
        errorMessage
        params
        source
        requestedBy
        parentJobId
        supersededByJobId
        attempts
        startedAt
        finishedAt
        createdAt
        cancelRequestedAt
        stalled
        terminal
        queuePosition
        blocker
        stagesTotal
        stagesDone
        stageLabels {
          key
          label
          state
        }
        outcome {
          key
          value
        }
        typicalSeconds
        etaSeconds
        childJobIds
      }
    }
  }
`;

export const enqueueMutation = graphql`
  mutation queueFragment_EnqueueMutation(
    $kind: String!
    $params: JSON
    $retryJobId: Int
  ) {
    accountJobEnqueue(kind: $kind, params: $params, retryJobId: $retryJobId) {
      outcome
      superseded
      job {
        jobId
        status
      }
      errors {
        message
      }
    }
  }
`;

export const cancelMutation = graphql`
  mutation queueFragment_CancelMutation($jobId: Int!) {
    accountJobCancel(jobId: $jobId) {
      outcome
      errors {
        message
      }
    }
  }
`;

export const scheduleSaveMutation = graphql`
  mutation queueFragment_ScheduleSaveMutation(
    $scheduleId: Int
    $kind: String
    $everyMinutes: Int
    $enabled: Boolean
  ) {
    jobScheduleSave(
      scheduleId: $scheduleId
      kind: $kind
      everyMinutes: $everyMinutes
      enabled: $enabled
    ) {
      schedule {
        scheduleId
      }
      errors {
        message
      }
    }
  }
`;

export const scheduleDeleteMutation = graphql`
  mutation queueFragment_ScheduleDeleteMutation($scheduleId: Int!) {
    jobScheduleDelete(scheduleId: $scheduleId) {
      deleted
      errors {
        message
      }
    }
  }
`;
